import {getStatusOptionsWithIcons} from '../components/pages/incidents/statusOptions'
import {endOfDay, isWithinInterval, parseISO, startOfDay} from 'date-fns'

export const incidentsFilterConfig = (text, teams, allMembers) => ({
    statuses: {
        type: 'select',
        key: 'statuses',
        className: 'status',
        label: text.status,
        showInDropdown: true,
        props: {
            options: getStatusOptionsWithIcons(text, true),
            isMulti: true,
            placeholder: text.choose_status
        },
        filterFn: (data, values) => {
            return values?.length
                ? data.filter(item => values.some(v => v.value === item.status))
                : data
        }
    },

    range: {
        type: 'date',
        key: 'range',
        className: 'date',
        label: text.updated,
        showInDropdown: true,
        filterFn: (data, rangeValue, isRangeSelected = false) => {
            if (!isRangeSelected || !rangeValue?.[0]?.startDate || !rangeValue?.[0]?.endDate) return data

            const [range] = rangeValue
            const startDate = startOfDay(new Date(range.startDate))
            const endDate = endOfDay(new Date(range.endDate))

            return data.filter(item => {
                const itemDate = parseISO(item.updated_at)
                return isWithinInterval(itemDate, {start: startDate, end: endDate})
            })
        }
    },

    urgencies: {
        type: 'select',
        key: 'urgencies',
        className: 'urgency',
        label: text.urgency,
        showInDropdown: true,
        props: {
            options: text.urgency_options,
            isMulti: true,
            placeholder: text.choose_urgency
        },
        filterFn: (data, values) =>
            values?.length
                ? data.filter(item => values.some(v => v.value === item.urgency))
                : data
    },

    teams: {
        type: 'select',
        key: 'teams',
        className: 'team',
        label: text.assignees,
        showInDropdown: true,
        props: {
            options: teams,
            isMulti: true,
            placeholder: text.choose_team
        },
        filterFn: (data, values) =>
            values?.length
                ? data.filter(item => values.some(v => item.assignees?.map(a => a.id).includes(v.value)))
                : data
    },

    members: {
        type: 'select',
        key: 'members',
        className: 'member',
        label: '',
        showInDropdown: true,
        props: {
            options: allMembers,
            isMulti: true,
            placeholder: text.choose_member
        },
        filterFn: (data, values) =>
            values?.length
                ? data.filter(item => values.some(v => item.assignees?.map(a => a.customer_id).includes(v.value)))
                : data
    },

    search: {
        type: 'input',
        key: 'search',
        className: 'search',
        label: text.search,
        props: {
            placeholder: text.search
        },
        filterFn: (data, value) => {
            if (!value) return data
            const lower = value.toLowerCase()
            return data.filter(
                item =>
                    item.name?.toLowerCase().includes(lower) ||
          item.description?.toLowerCase().includes(lower)
            )
        }
    },

    resource_type: {
        type: 'select',
        key: 'resource_type',
        id: 'resource-type',
        className: 'resource-type',
        label: text.resource_type,
        showInDropdown: true,
        props: {
            options: Object.values(text.resource_options),
            placeholder: text.choose_resource_type,
            blurInputOnSelect: true,
            customAfter: true
        },
        filterFn: (data, resourceType) => {
            if (!resourceType || resourceType.value === text.resource_options.all.value) return data
            return data.filter(item => resourceType?.trigger_type === item?.trigger_source?.split('#')[0])
        }
    }
})
